// NBAConstants.js
/**
 * @module NBAConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const NBAConstants
 */
export default keyMirror({
  REQUEST_NBA_DATA: null,
  REQUEST_NBA_DATA_SUCCESS: null,
  REQUEST_NBA_DATA_ERROR: null,

  REQUEST_SPLASH_DATA: null,

  REQUEST_NBA_PRODUCT_DATA_SUCCESS: null,
  REQUEST_NBA_PRODUCT_DATA_ERROR: null,

  REQUEST_NBA_SETTINGS: null,
  REQUEST_NBA_SETTINGS_SUCCESS: null,
  REQUEST_NBA_SETTINGS_ERROR: null,

  REQUEST_SPLASH_ACK: null,
  REQUEST_SPLASH_ACK_SUCCESS: null,
  REQUEST_SPLASH_ACK_ERROR: null,

  REQUEST_C_CONTAINER_ACK: null,
  REQUEST_C_CONTAINER_ACK_SUCCESS: null,
  REQUEST_C_CONTAINER_ACK_ERROR: null,

  NBA_CLOSE: null,
  REQUEST_SPLASH_DATA_SUCCESS: null,
  REQUEST_SPLASH_DATA_ERROR: null,
});
